import {
  firmStandardsRecordReadSchema,
  type FirmStandardsRecord,
  type FirmStandardsSaveRequest,
} from "@contract/standards/standards";
import { apiRequest } from "./client";

/** GET /v1/firm/standards: every active member may read (firm-model spec §6.2). The
 * standards parse field by field: a stale field reads as Not set, never a failed page. */
export function fetchFirmStandards(): Promise<FirmStandardsRecord> {
  return apiRequest("/v1/firm/standards", {}, (json) => firmStandardsRecordReadSchema.parse(json));
}

/** PUT /v1/firm/standards (`edit_standards`): answers the saved record, or refuses with
 * `stale_version` when someone saved since `request.version` was loaded. */
export function saveFirmStandards(request: FirmStandardsSaveRequest): Promise<FirmStandardsRecord> {
  return apiRequest("/v1/firm/standards", { method: "PUT", body: request }, (json) => firmStandardsRecordReadSchema.parse(json));
}
